import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import { listEncabezadosTipoContrato } from "./models";
import ReactHtmlParser from "react-html-parser";
import { Typography } from "@material-ui/core";
import { numeroOrdinal } from "./models";
import utils from "../../utils/utils";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
}));

export default function ContractTypeFormatTable({ clauses, contracType }) {
  let textoClausulas = "";

  clauses &&
    clauses.forEach((element, index) => {
      textoClausulas +=
        "<strong>" +
        numeroOrdinal[index].toUpperCase() +
        ": " +
        element.name +
        "</strong> " +
        element.definitionClause +
        " ";
    });

  return (
    <div>
      <Grid
        container
        spacing={4}
        style={{
          border: "1px black solid",
          backgroundColor: "white",
        }}
      >
        {listEncabezadosTipoContrato.map((modelo) => (
          <Grid
            item
            xs={6}
            key={modelo.id}
            style={{
              border: "1.5px black solid",
              backgroundColor: "white",
            }}
          >
            <Typography>{modelo.title}</Typography>
          </Grid>
        ))}
      </Grid>
      <Grid
        container
        spacing={4}
        style={{
          border: "1px black solid",
          backgroundColor: "white",
        }}
      >
        <Grid
          item
          xs={12}
          style={{
            border: "1.5px black solid",
            backgroundColor: "white",
          }}
        >
          <Typography>{contracType?.headerInformation}</Typography>
          <div style={{ textAlign: "justify", marginTop: "10px" }}>
            {ReactHtmlParser(utils.replaceTextDynamicClauses(textoClausulas))}
          </div>
        </Grid>
      </Grid>
    </div>
  );
}
